export default function initializeFields(fields: string[]): void {
  fields.forEach((field) => {
    const element = document.getElementById(field) as HTMLInputElement;
    if (!element) return;
    element.value = '';
  });
}
